import netsSideDrawer from './nets-side-drawer';

export default angular
  .module('app.side-drawer', [])
  .component('netsSideDrawer', netsSideDrawer);
